import { apiAction } from '../ajax/service';
import { initializeAuth, setAuthentication, setWorkspaces } from '../features/authSlice';
import { setCookie } from '../helpers/helper';



/**
 * Handles user login.
 * On success, saves tokens to localStorage and dispatches authentication status.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {object} credentials - The user's email and password.
 */
export const loginUser = async (dispatch, credentials) => {
    const response = await apiAction('auth', credentials, 'login');
    // On successful login, we get a temporary token.
    // We are not "fully" authenticated until a workspace is selected.

    // We don't set isAuthenticated to true yet.
    return response; // Return response so the component can navigate.
};

/**
 * Fetches the list of workspaces for the user.
 * @param {function} dispatch - The Redux dispatch function.
 */
export const fetchWorkspaces = async (dispatch) => {
    const response = await apiAction('workspace', {}, 'get_workspaces');
    dispatch(setWorkspaces(response?.data));
};

/**
 * Handles selecting a workspace.
 * On success, saves the scoped session token and workspace, clears the temp token,
 * and dispatches the final authentication status.
 * @param {function} dispatch - The Redux dispatch function.
 * @param {string} workspaceId - The ID of the workspace to select.
 */
export const selectWorkspace = async (dispatch, workspaceId) => {
    const response = await apiAction('workspace', { workspaceId }, 'choose_workspace');
    if(response?.token)
    setCookie('tempAuthToken', response?.token);

    if (response?.workspace)
    sessionStorage.setItem('selectedWorkspace', response?.workspace);
     // Clean up the temporary token
    if(response?.showSplash)
    localStorage.setItem('showSplash',true)

    dispatch(setAuthentication(true)); // Now the user is fully authenticated
    return response;
};

/**
 * Handles user signup.
 * @param {object} credentials - The user's email and password.
 */
export const signupUser = async (credentials) => {
    const response = await apiAction('auth', credentials, 'signup');
    setCookie('tempAuthToken', response?.token);
    return response;
};

/**
 * Handles OTP verification.
 * @param {object} otpData - The user's email and OTP.
 */
export const verifyOtp = async (otpData,dispatch) => {
    const response = await apiAction('auth', otpData, 'verify_otp');
    setCookie('tempAuthToken', response.token);
    dispatch(initializeAuth())
    return response
}

/** * Handles forgot password.
 * @param {object} emailData - The user's email.
 */
export const forgotPassword = async (emailData) => {
    return await apiAction('auth', emailData, 'forgot_password');
}

/**
 * Handles verifying reset token.
 * @param {object} data - The user's email and reset token.
 */
export const verifyResetToken = async (data) => {
    return await apiAction('auth', data, 'verify_reset_token');
}

/**
 * Handles updating the password.
 * @param {object} data - The user's email and new password.
 */
export const updatePassword = async (data) => {
    return await apiAction('auth', data, 'update_password');
}

/**
 * Handles Google Oauth
 * @param {object} data - The Google ID token.
 */
export const googleAuth = async (data) => {
    const response = await apiAction('auth', data, 'google_oauth');
    setCookie('tempAuthToken', response.token);
    return response;
}

